import { render, staticRenderFns } from "./braces-reissue-table.vue?vue&type=template&id=c57c9dd0&scoped=true"
import script from "./braces-reissue-table.vue?vue&type=script&lang=js"
export * from "./braces-reissue-table.vue?vue&type=script&lang=js"
import style0 from "./braces-reissue-table.vue?vue&type=style&index=0&id=c57c9dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57c9dd0",
  null
  
)

export default component.exports